import React, { FC, memo, useCallback } from 'react'
import { Slide } from 'pure-react-carousel'

import { useTranslation } from '../../../hooks/locale'
import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import GridCard from '../../region-landing-page/common/grid-card'
import AnalyticsService from '../../../services/analytics-service'
import { landingPageEventCategories } from '../../../services/analytics-service/categories'
import { CtaButtonText, CtaContainer, Section, StyledGhostButton, Title, TitleContainer } from '../common/styles'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import PrevNextControls from '../../common/prev-next-controls'
import { useResponsiveCards } from '../../../hooks/responsive'
import { SliderContainer, StyledCarouselProvider, StyledSlider } from '../../common/listing-card-section/styles'

interface Props {
    listingSection: ListingSectionTransport
    url: string
    breadcrumbList?: BreadcrumbListTransport
    sitePathname?: string
    defaultHeading: string
}

const TopRecommendationsSection: FC<Props> = ({
    listingSection,
    breadcrumbList,
    url,
    sitePathname,
    defaultHeading,
}) => {
    const { objects, cta } = listingSection
    const { t } = useTranslation()

    const heading = listingSection.heading || defaultHeading

    const _handleCTAButtonClick = useCallback(() => {
        const eventCategory = landingPageEventCategories.topRecommendationsSection.BOTTOM_CTA_VIEW_RECOMMENDATIONS

        if (cta?.url) {
            AnalyticsService.trackClickEvent(eventCategory, cta.url)
            document.location.href = cta.url
        }
    }, [cta?.url])

    const visibleSlides = useResponsiveCards()
    const dragStep = Math.floor(visibleSlides)

    return (
        <Section id="top-recommendations">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <SliderContainer>
                <StyledCarouselProvider
                    totalSlides={objects.length}
                    visibleSlides={visibleSlides}
                    naturalSlideWidth={1}
                    naturalSlideHeight={1}
                    isIntrinsicHeight
                    lockOnWindowScroll
                    dragStep={dragStep}
                    step={dragStep}
                >
                    <PrevNextControls totalObjects={objects.length} visibleSlides={visibleSlides} />
                    <StyledSlider $transitionTime={0.2}>
                        {objects.map((object, index) => (
                            <Slide index={index} key={object.id}>
                                <GridCard
                                    listingObject={object}
                                    position={index}
                                    breadcrumbList={breadcrumbList}
                                    requestUrl={url}
                                    sitePathname={sitePathname}
                                />
                            </Slide>
                        ))}
                    </StyledSlider>
                </StyledCarouselProvider>
            </SliderContainer>
            {!!cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleCTAButtonClick} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Section>
    )
}

export default memo(TopRecommendationsSection)
